import EmailShareIcon from "../widgets/rewards_hub_widget/v1/components/icons/SocialShareIcons/EmailShareIcon.svelte";
import FacebookShareIcon from "../widgets/rewards_hub_widget/v1/components/icons/SocialShareIcons/FacebookShareIcon.svelte";
import PinterestShareIcon from "../widgets/rewards_hub_widget/v1/components/icons/SocialShareIcons/PinterestShareIcon.svelte";
import TwitterShareIcon from "../widgets/rewards_hub_widget/v1/components/icons/SocialShareIcons/TwitterShareIcon.svelte";
import WhatsAppShareIcon from "../widgets/rewards_hub_widget/v1/components/icons/SocialShareIcons/WhatsAppShareIcon.svelte";

export enum REWARDS_SOCIAL_SHARE_CHANNEL_TYPES {
    facebook = "facebook",
    twitter = "twitter",
    whatsapp = "whatsapp",
    pinterest = "pinterest",
    email = "email",
}

export type REWARDS_SOCIAL_SHARE_CHANNEL_TYPE =
    `${REWARDS_SOCIAL_SHARE_CHANNEL_TYPES}`;

export const REWARDS_SOCIAL_SHARE_ICONS = {
    [REWARDS_SOCIAL_SHARE_CHANNEL_TYPES.facebook]: FacebookShareIcon,
    [REWARDS_SOCIAL_SHARE_CHANNEL_TYPES.twitter]: TwitterShareIcon,
    [REWARDS_SOCIAL_SHARE_CHANNEL_TYPES.whatsapp]: WhatsAppShareIcon,
    [REWARDS_SOCIAL_SHARE_CHANNEL_TYPES.pinterest]: PinterestShareIcon,
    [REWARDS_SOCIAL_SHARE_CHANNEL_TYPES.email]: EmailShareIcon,
};

export const REWARDS_SOCIAL_SHARE_TOOLTIP = {
    [REWARDS_SOCIAL_SHARE_CHANNEL_TYPES.facebook]: "facebook_tooltip",
    [REWARDS_SOCIAL_SHARE_CHANNEL_TYPES.twitter]: "x_tooltip",
    [REWARDS_SOCIAL_SHARE_CHANNEL_TYPES.whatsapp]: "whats_app_tooltip",
    [REWARDS_SOCIAL_SHARE_CHANNEL_TYPES.pinterest]: "pinterest_tooltip",
    [REWARDS_SOCIAL_SHARE_CHANNEL_TYPES.email]: "email_tooltip",
};
